import gql from 'graphql-tag';

export const REMOVE_TAG = gql`
  mutation editTag($tagId: Int!) {
    tagMutation {
      removeTag(tagId: $tagId)
    }
  }
`;
